module.exports = __webpack_public_path__ + "img/marker.df936b37.svg";